import { render, staticRenderFns } from "./sectionFooter.vue?vue&type=template&id=4ed8203f&scoped=true&"
import script from "./sectionFooter.vue?vue&type=script&lang=js&"
export * from "./sectionFooter.vue?vue&type=script&lang=js&"
import style0 from "./sectionFooter.vue?vue&type=style&index=0&id=4ed8203f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed8203f",
  null
  
)

component.options.__file = "sectionFooter.vue"
export default component.exports